import { render } from "./BoardDetailTemplate.vue?vue&type=template&id=7a52786c&scoped=true"
import script from "./BoardDetailTemplate.vue?vue&type=script&lang=js"
export * from "./BoardDetailTemplate.vue?vue&type=script&lang=js"

import "./BoardDetailTemplate.vue?vue&type=style&index=0&id=7a52786c&scoped=true&lang=css"
import "./BoardDetailTemplate.vue?vue&type=style&index=1&id=7a52786c&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a52786c"

export default script